import { render, staticRenderFns } from "./MenuEditProfileIcon.vue?vue&type=template&id=6e396b00&scoped=true&"
import script from "./MenuEditProfileIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuEditProfileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEditProfileIcon.vue?vue&type=style&index=0&id=6e396b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e396b00",
  null
  
)

export default component.exports